<!--
<import-excel ref="importExcel" title="导入关键词"
                :action="baseURL+'/api/mgr/yyq/userKeyword/importKeyword'"
                :download-url="baseURL+'/api/mgr/yyq/userKeyword/downloadKeywordTemp'"
                :error-url="baseURL+'/api/mgr/yyq/userKeyword/downloadErrorImportList'"
                @on-success="loadData"
-->
<template>
  <el-dialog :title="title" v-model="importExcelDialog" width="500px" :close-on-click-modal="false" :show-close="false" v-show="importExcelDialog"  append-to-body>
      <el-form  ref="importExcelForm"  label-width="120px" >
        <el-form-item v-show="!importThreadStatus" label="文件" >
          <div class="flex-cc">
            <el-upload
              v-if="importExcelDialog"
              ref="upload"
              :action="action"
              class="upload-demo"
              accept=".xls,.xlsx"
              name="file"
              :data="data"
              :limit="1"
              :on-success="importThread"
              :headers="headers">
              <el-button type="primary">点击上传</el-button>
            </el-upload>
            <div class="el-upload__tip">只能上传excel文件，<a class="primary cp" @click="downloadTemp()">模版下载</a></div>
          </div>

        </el-form-item>
          <el-form-item v-show="importThreadStatus" label="导入进程" label-width="120px">{{importObj.processNum}}/{{importObj.totalNum}}
          </el-form-item>
          <el-form-item v-show="importThreadStatus" label="导入情况" label-width="120px">{{importObj.tips}}</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-show="!importThreadStatus" @click="importExcelDialog =false">取 消</el-button>
        <el-button v-show="importThreadStatus" type="primary" @click="finishImport()" :loading="importObj.status">{{ importObj.btnText }}</el-button>
        <el-button v-show="importThreadStatus" @click="exportErrorList()" :disabled="importObj.status" v-if="importObj.totalNum-importObj.successNum>0">下载导入错误文件</el-button>
      </span>
  </el-dialog>
</template>

<script>

  export default {
    name: "importExcel",
    props: ["title","action","downloadUrl","errorUrl","btn",'data'],
    data() {
      return {
        importExcelDialog: false,
        headers:{'token':localStorage.getItem("qc_token")},
        importId:'',
        importObj:{
          processNum: 0,
          totalNum: 0,
          tips: '',
          status: true,
          btnText: '导入中',
          successNum:0
        },
        importThreadStatus:false,
      }
    },
    methods: {
      importThread(response, file) {
        if(response.code==0){
          this.importId = response.data;
          this.importThreadStatus = true;
          var statusId = window.setInterval((date)=>{
            this.simplePost("/api/open/queryImportStatus", {id: this.importId}, result=>{
              this.importObj.processNum = result.data.processNum;
              this.importObj.totalNum = result.data.totalNum;
              if (result.data.isFinish) {
                this.importObj.processNum = result.data.processNum;
                this.importObj.successNum = result.data.successNum;
                this.importObj.tips = result.data.tips;
                this.importObj.status = false;
                this.importObj.btnText = '导入完成';
                window.clearInterval(statusId);
              }
            });
          }, 5000);
        }else{
          this.msgAlert(response.desc);
        }
      },
      downloadTemp(){
        this.exportExcelFile(this.downloadUrl,"",this.data);
      },
      exportErrorList(){
        this.exportExcelFile(this.errorUrl,"确认导出错误文件?",{id:this.importId,...this.data});
      },
      finishImport(){
        this.$refs.upload.clearFiles();
        this.importThreadStatus = false;
        this.importObj={
          processNum: 0,
            totalNum: 0,
            tips: '',
            status: true,
            btnText: '导入中',
            successNum:0
        };
        this.$emit('onSuccess');
      },
      openDialog() {
        this.importExcelDialog = true;;
      }
    },
    mounted() {
     }
  }
</script>


<style lang="less" scoped>

</style>
